import { connect } from 'react-redux'
import { AnnouncementOverlay } from './'
import { getAllAnnouncements } from '../../../reducers/selectors'

function fetchAllTest() {
  console.log('test')
}

interface IStateProps {
  content: any
}
interface IDispatchProps {
  fetchAllTest: () => void
}
export default connect<IStateProps, IDispatchProps, void>(
  (state: any) => ({
    content: getAllAnnouncements(state),
  }),
  {
    fetchAllTest,
  },
)(AnnouncementOverlay)



// WEBPACK FOOTER //
// ./src/components/Shared/announcementOverlay/announcementOverlay.conn.tsx